import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxUploadTrackerService } from './upload-tracker.service';

export const ngxUploadTrackerServiceModule = angular.module('ngxUploadTrackerServiceModule', [])
	.factory('ngxUploadTrackerService', downgradeInjectable(NgxUploadTrackerService) as any)
	.name;
